<template>
  <div class="main-content bg-main">
    <!-- Header -->
    <div class="header bg-gradient-primary py-8 pb-lg-6 pt-lg-4">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Foto Absentsi</h1>
              <!-- <p class="text-lead text-white"></p> -->
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-absent" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <!-- Page content -->
    <div class="container mt--9 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-7">
          <div class="card border-0 mb-0">
            <div class="card-body px-lg-3 py-lg-3 text-center">
              <div v-if="error" class="err-msg">
                <div>Kamu tidak dapat melihat gambar ini</div>
                <div>Untuk melihatnya</div>
                <router-link to="/auth/login">Login Sekarang</router-link>
              </div>
              <div v-else>
                <div v-if="isLoading" class="err-msg">
                  <div>Mengambil gambar...</div>
                </div>
                <img
                  v-else
                  class="col-12 p-0 absent-img"
                  :src="'data:image/png;base64,' + image"
                  alt="Image placeholder"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPhotoAbsent } from "@/services/attendances";

export default {
  data() {
    return {
      image: "",
      error: false,
      isLoading: false,
    };
  },
  methods: {
    async getFoto() {
      try {
        this.isLoading = true;
        const response = await getPhotoAbsent(this.$route.params.id);
        const { data } = response.data;
        this.image = data;
        this.isLoading = false;
      } catch (err) {
        if (err.response.data) {
          this.error = true;
        }
        this.isLoading = false;
      }
    },
  },
  created() {
    this.getFoto();
  },
};
</script>

<style lang="scss" scoped>
.fill-absent {
  fill: rgb(44, 44, 44);
}

.bg-main {
  height: auto;
  background-color: rgb(44, 44, 44);
}

.absent-img {
  object-fit: contain;
  border: 1px solid rgb(163, 163, 163);
}

.err-msg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 506px;
  text-align: center;
  font-size: 25px;
}
</style>
